import { render } from "./post-crash-repairs.vue?vue&type=template&id=73d85e61&scoped=true"
const script = {}

import "./post-crash-repairs.vue?vue&type=style&index=0&id=73d85e61&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73d85e61"]])

export default __exports__